export const PROD_API = 'https://srv-qbb.hkatv.vip/missasia';
export const TEST_API = 'https://srv-qbb-test.hkatv.vip/missasia';
// export const PROD_URL = 'https://missasia-admin.hkatv.vip';
export const API_PREFIX = process.env.NODE_ENV === 'production' ? PROD_API : TEST_API;
export const ALI_OSS_PREFIX = 'xuanmei_adm';
export const HEADER_MENUS = [];
export const AUTH_KEY = 'XMA-AUTH';
export const GAMEAREA_KEY = 'GAMEAREAID';
